import { createClient } from "@supabase/supabase-js";

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? "https://nbdhsymupyvhxkknvwzt.supabase.co";
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "sb_publishable_iPCE5ZUTAZ4Cz8T14P1iPA_6X7peHz6";

export const supabase = createClient(SUPABASE_URL, anonKey);

export async function signInWithGoogle(redirectTo?: string) {
  const redirect = redirectTo || `${window.location.origin}/dashboard`;
  return supabase.auth.signInWithOAuth({
    provider: "google",
    options: { redirectTo: redirect },
  });
}
